import React from 'react';
import NavItem from './NavItem';
import {
  QuestionnairesIcon,
  TasksIcon,
  DocumentsIcon,
  AddSmallIcon,
  AILogo,
  EnvelopeIcon,
  PasswordProfileIcon,
  ManageProjectsIcon,
  PercentageIcon,
  DelayIcon,
} from 'assets/icons';
import UnreadMessagesCount from './UnreadMessagesCount';

interface CommonMenuProps {
  taxReturnsPath: string;
  handleToggle: (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isTaxExpanded: boolean;
  setIsTaxExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isFinCenExpanded: boolean;
  setIsFinCenExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  showServices?: boolean;
}

export function commonMenu({
  taxReturnsPath,
  isTaxExpanded,
  setIsTaxExpanded,
  isFinCenExpanded,
  setIsFinCenExpanded,
  handleToggle,
  showServices = true,
}: CommonMenuProps) {
  return (
    <>
      <NavItem
        icon={QuestionnairesIcon}
        name="Dashboard"
        path="/dashboard/home"
        className="custom-menu-item"
      />
      <NavItem
        icon={TasksIcon}
        name="Tasks"
        path="/dashboard/tasks"
        className="custom-menu-item"
      />
      <div className="custom-menu-item">
        <NavItem
          icon={ManageProjectsIcon}
          name="Tax"
          path="#"
          className="custom-menu-item"
          onClick={handleToggle(setIsTaxExpanded)}
          showArrow
          isExpanded={isTaxExpanded}
          isDropdownToggle
        />
        {isTaxExpanded && (
          <div className="pl-4">
            <NavItem
              icon={ManageProjectsIcon}
              name="Returns"
              path={taxReturnsPath}
              className="custom-menu-item"
            />
            <NavItem
              icon={PercentageIcon}
              name="Estimates"
              path="/dashboard/taxEstimates"
              className="custom-menu-item"
            />
            <NavItem
              icon={DelayIcon}
              name="Extensions"
              path="/dashboard/taxExtensions"
              className="custom-menu-item"
            />
            <NavItem
              icon={DocumentsIcon}
              name="FinCEN"
              path="#"
              onClick={handleToggle(setIsFinCenExpanded)}
              showArrow
              isExpanded={isFinCenExpanded}
              isDropdownToggle
            />
            {isFinCenExpanded && (
              <div className="pl-4">
                <NavItem
                  icon={DocumentsIcon}
                  name="Reports"
                  path="/dashboard/fincenReports"
                  className="custom-menu-item"
                />
              </div>
            )}
          </div>
        )}
      </div>
      <NavItem
        icon={DocumentsIcon}
        name="Documents"
        path="/dashboard/documents"
        className="custom-menu-item"
      />
      {showServices && (
        <NavItem
          icon={AddSmallIcon}
          name="Services"
          path="/dashboard/services"
          className="custom-menu-item"
        />
      )}
      <NavItem
        icon={AILogo}
        name="AI Mito"
        path="/dashboard/ai-mito"
        className="custom-menu-item"
      />
      <NavItem
        icon={EnvelopeIcon}
        name="Messages"
        path="/dashboard/messages"
        className="custom-menu-item"
        suffix={<UnreadMessagesCount />}
      />
      <NavItem
        icon={PasswordProfileIcon}
        name="Privacy Policy"
        path="/dashboard/privacy-policy"
        className="custom-menu-item"
      />
    </>
  );
}
